import $ from 'jquery';
import {DiagramEditor, decompressXML} from "./diagramEditor";
import diagramFile from "../../resources/parent_test.drawio.svg"
import errorFile from "../../resources/ErrorMessage.drawio.xml"
import {errorMapping, NodeTypeMapping} from "./nodeMappings";
import * as diagramParsing from "./diagramParsing";

export function DietDiagram() {
    let conf = {
        css: " .geTabContainer, .geToolbarContainer.geSidebarContainer, .mxWindow, .geMenubar > :not(.geStatus)  { display: none !important; }" +
            ".geToolbar a:nth-last-child(-n+16), .geToolbar .geSeparator:nth-last-child(-n+16){ display: none !important; }",
        /*css: ".mxWindow, .geTabContainer, .geToolbarContainer, .geMenubarContainer>div:nth-child(-n + 2), .mxPopupMenu { display: none !important; }" +
            ".geToolbar a:nth-last-child(-n+16), .geToolbar .geSeparator:nth-last-child(-n+16){ display: none !important; }",*/
        /*css: ".geTabContainer, .geToolbarContainer, .geMenubarContainer>div:nth-child(-n + 2), .mxPopupMenu { display: none !important; }" +
            ".geToolbar a:nth-last-child(-n+16), .geToolbar .geSeparator:nth-last-child(-n+16){ display: none !important; }",*/
        libraries: [{
            "title": {
                "main": "Diet"
            },
            "entries": [{
                "id": "diet-graphics",
                "title": {
                    "main": "Diet Graphics",
                },
                "desc": {
                    "main": "Collection of Graphics for Diets",
                },
                "libs": [
                    {
                        "title": {
                            "main": "Diets"
                        },
                        "data": [{
                            "xml": "dVJLbsIwED2Nl1SJzS/LklJWrSrBBUwyJW4dT+S4BDh9x7EpRiqLSH7zPp6Mh4myPW2s7Jo3rEEzsWaitIgunNpTCVoznqmaiRfGeUYf468P2Hxks05aMO4fA+6/oHKk0HLvL/OCneqQKmQgk2wVHTDEGOpod+4g6JRxYFuolXTwTkzQXG/mHt431buzjl6LP6YGL82ZWA2NcrDtZOXZgf6dao1rdaQ/ldYlarSjVxR8vVxOqd47i9+QMLwocpF5BxqX1EUhytncO4zsdviBahyGV1ZoDE1A7sfO/G1SaxyercWhj5UWjwlvoVeXBFcaDUTsEy06mebRI0KKaWAp9K1u1WWENLBVmOIRrIPTwzfMk+FuAFtw9kySc2An/IkvxELMF7PpVNBYsjlMchFiBlW7JqbEXcgaUIcmRotYk33Ah7/429bQIT7qFcY9usLbvo7Su3X+BQ==",
                            "w": 120,
                            "h": 30,
                            "aspect": "fixed",
                            "title": "Entrenamiento base"
                        }, {
                            "xml": "dVLNbsIwDH6a3NtGA+04uo3TpknwAqExNFsSV6mhwNPPadMRpHGolO8vcW0LWbvzOqiu/UANVsg3IeuASNPJnWuwVlSF0UK+iqoq+BPV+wO1HNWiUwE8/RPA3Tc0xA6rdvGxaNiaDpnhAIeUM3zA6RrPFW0vHUw+4wmCA20UwScrk2d+uYrwvqieLjZlAx69hmgthVwNrSHYdKqJ6sD/zlxLziZ5b6yt0WIYsxJK/QRL5nsK+AOZ8rxYSrWICfQ08xr26mgp+r3qtviFZmxFwUyD3vP/q91YV3xLWYvDSwg49IlxeMr0AL25Zrix6CHheGNAUvl9PELIMbcrh7HQjbmOkNu1mnp4gkBwfjjBMmvtGtABhQtbBqOpTY405aIFc2hTTCZO9RM+/EVv+8CHNK4Zpg2Z4W0TR+vdov4C",
                            "w": 120,
                            "h": 30,
                            "aspect": "fixed",
                            "title": "Entrenamiento extra"
                        }, {
                            "xml": "dVRb05o6FP01zpzz0A6EmzwqKHgtVLz1LUKE8EWiSQDx1zcItn7ntDMwk73X2hfC3mugOZe7x+A1W9EEkYE2GWgOo1R0p8vdQYQMgIKTgeYOAFDkOwDTv6DqE1WukKFC/CGAnnIUi5ZBYIwyShLEOloFSYm66O74FvzO5p8KFbLnqLn27AQKuJaeDnv1BFrzc7tcNKSP4Rl8hnOBihiTf8QuEhFd1VMfQNl2fggx/ZAHd8+AR4CRz8sdYZvpKTLta7hNzNXoSHCzioFV6bFrz5xGm+4HYDxSFiG25rvwguG80q7Dy2VaevdR+ZEpWhPEmyMPTarbdc1na++W3lbfcnPh87w5cllPfvnUPi7Z980h3aj8Gsx2SbOMd6FMvX4QnyP/Tmpyq3x97fJ7umKLSVXZiY09K9fG5tyyI5D4tlGY2sTQzai0d+UKTNq88llyUT+EcTsZB17mKcr36mEI8Y9J5Npxo7SsYpgbd3+WL31r1DjGsdp7MwNuAf/mKN+dIheOPQT21r3ujqUX7Jk+rKqZCsr93N4OM0buKMjmOCpD/5RuA1c9LzyyzixPpjbG64UXBMuV/BhE2CopplqceGuoFv4P6SPnWX298B3KeBhsLCwuSu4EH5N0eNum862mlmPrZukeFfiwaC/EGM1uy5DXCVOWZzWsue/PxxKYRf8OtHGdYYE2VzlD8kfXctalr6BLeGrn3VWldcaEOJTQbhi16ci1XUP6uWD0A70jwHTNoURIGx1QjgWmhcRiOfDtLI8rxASOIVn+hyBoWxYSnP6RPuqBjsZls7hIpS1Hd5xRhh+0EPDVbg9HLddV9Vc7Yxh/pIyWRfLqOEFnWBLxi0CZXKH/g2eZfIMf6JUtpkUh9xSenluiPvsmtB4xRmveey60esMZ4vjxZseEFqi3lRanAr7nk1KD3m2U4Hezu/c9TkTWe3ppkLeF7n/VGvVt1T1EL0iwRlKaDv2ifrUUQ1OAYRpDoANd0dEXVevS1H2tNstLdjKE06xPrSlfQeeFvQSlvwr81jd56EXmZfaK9zJ/K+uT+kl4fwI=",
                            "w": 120,
                            "h": 30.199999999999996,
                            "aspect": "fixed",
                            "title": "Unidades"
                        }, {
                            "xml": "dVRb06I4EP01Vu2+cVV5FFDwggMj3uYtQoRgIJgEEH/9BIUZv92ZKqhK9zndOYTOGalW/nAoKFOPxBCP1PlItSgh/L3KHxbEeKRIKB6p9khRJPGOlMVfUPmFSiWgsOB/KCCXDEa8Y2AQwZTgGNI3rQa4gu/q9/Kj+JPNvmxUCM1hW/bsGHCwFZk3NmhSuvCrXMZb3NewFLzKGYdFhPA//BDykHjNwlWAkJ2dAkRuYmEfqeJgRc9W1QHT3eISjo0y2Mdjb3bGqPUiZVJrkW0srVZdHEeKOZPWAZqsDkGOwKpWy2meLyrnMatuqaS2frQ7s2BMNKNp2HLr3JO79y0br12WtWcm9hNfvjDOG/p9d0p2Miv95SFuN9EhEK23T+wy6D5wg++1q21t9kg8up7XtREbyJlkqjleTYxQiV1DL8bqXNfGYWUcKk+Zd33Fs2G8eXL9ftFPrMoSmB3l0xSgH/PQNqJW6ljFNNMf7jLbuJNZa+nn+ugsdbBX2DdL+m4VGbeMqWLs7fJwrhz/SLVpXS9lpTqujP00pfgB/XSFwipwL8net+Xr2sHbdOKI1rq5XTu+v/HEx0BMvbhYqFHsbIFcuD9EDl+XTZmzA0xZ4O8miOdSZvm3eTK975PVXpUrc3KfaA7h6LTuDkSfLe+bgDUxlTZXOWiY665MASzDf0eq2aSIw10pZkj86EbMusgVZAMu3bzbsoiuCGOLYPIeRvUCommsijzjlNzgB6KomqaLwTJxV+0ThjgihcAiMfDdLJs1pBxFAG/+Q+Ck2xZglPyRPuuBN40JsahIRCxG10wJRU9ScDDI7eGw49qyNsgxQXRLKKmKeFAcwyuoMP9FIFRcof+DV9F8h55w6BaRohD3FFxet0R+6cakmVFKGtZnclJ/4BQy9PyII0wK2MdShxMOPvsJq4GfMYzRZ/g+9yOKeTpkClCGxCfo5SvSILq/yB2jNw9xnvDxVzeSP8zAgSSHnLaC0vQ7dYzBdFKIkrQvU/sc6O0n+VX629vEojeYIezdbgh/u+qL+sV0fwI=",
                            "w": 120,
                            "h": 30,
                            "aspect": "fixed",
                            "title": "Unidades"
                        }, {
                            "xml": "dVTZsqIwEP0aqmbeWETlUUDBBQdG3OYtQoRgJJgEEL9+guC93lmqpCrd5+SkE7uPpFnXu0NBkXokhljSppJmUUJ4t7reLYixpMooljRbUlVZfJI6+w+qPFG5ABTm/B8byCmDEW8ZGEQwJTiGtKNVAJew290tv+h9stkXIBc1h03Rs+OSAo5IvhbZDueEYI6KDu5SGJzaa76JvIp/Er7ei/EG9+IsBc9zGId5hPA3vgt5SLx65qpA3C87BIhcxMLeU9XBqp4tyh2mm9kpHBpFsI2H3uSIUeNF6qgaRLYxtxpttpdUcyIvAzRa7IIrAotKK8bX66x07pPykspa40ebIwuGZGDUNZuvnVty835kw6XLsubIxHnifWfGcUV/bg7JRmGFP9/FzSraBUJ6/cAug+4d1/hWuYO1ze6JR5fTqjJiAzmjTDOHi5ERqrFr6PlQm+qDYVgau9JTp62u+K0Yrx9cv530AyuzBGZ75TAG6Nc0tI2okVtWPs70uzvPVu5o0lj6sdo7cx1sVfbDkn9aecYtY6waW7vYHUvH39PBuKrmilruF8Z2nFJ8h366QGEZuKdk69vKeengdTpyhLRurpeO7688cRmIqRfnMy2KnTVQcveXyOHzvC6ubAdTFvibEeJXObP8yzQZ37bJYqsppTm6jQYO4eiwbB9En8xvq4DVMZVXZyWomesuTAHMw++SZtYp4nBTiGYTf3QthkLkcrLqO0YR0RlhbBFMuq7VTNuWZ5bIM07JBb4hQ2s8NUXXm89+8wlDbWcKLBKT0Ta9WUHKUQTw6g8CJ+2xAKPkn/RJD3Q0JopFeSJi0bpmSih6kJyDV7k9HLZcWxm8yjFBdEkoKfP4VXEMz6DE/INAqJi1v8GzEN+gB3ypRSTPxUCD03NKlGfdmNQTSknN+syVVG84hQw93uIIkxz2sdzihIN3PeFJ8D2GMXoPu3ffo5inr0wKYlL3ar2hiKeD9/86lPI29w4kV8hpIyh1L9oyeheTU4iStN+m9TnQW1LysfXT78Si95JX2DvgK/x02if1ixH/Bg==",
                            "w": 120,
                            "h": 30,
                            "aspect": "fixed",
                            "title": "Duracion baja"
                        }, {
                            "xml": "dVTZsqIwEP0aq2beWETkUVDBdWDEbd4iiRAMBJMA4tdPULzXO0uVVKX7nHR32u7T053s5jJQJCsKEenpk57uMErF85TdHERIT1Mw7OnjnqYp8utp0/+g6gNVCsBQLv5xgZ5SFImWQUCEEkogYk9aBUiJnrefx4e338X7ZPMviXJZc9gUHRuWDAhM87X0PnFBKRG4eMJPFwGn9plv0V/FPwhf38VFQ7rgPAGPPFygPMLkm9iFIqSreuppQL4vPQSYXuRhvGeaSzQjnZc7wjbTUziwimALB6vRkeBmFWlm1Y/G1sxp9Om+p9kjZRFgc74LMgzmlV4Ms2xaurdReUkUvfGjzZEHA9q36prP1u41vq5+pIOFx9PmyGU+2d+pdVyyn5tDvFF54c92sFlGu0CGXt+Jx5F3IzW5Vl5/Pea3eMUWk6qyoIVdM9Xtwdy0Qg16lpEP9InRH4SltStX2qSNK39LLuq7MK4n48DLNEbpXj0MAf41CcdW1CgtKx+mxs2bpUvPHDWOcaz27swAW43/cJSfTp4Kxxpq1nZc7I6l6+9Zf1hVM1Ur93NrO0wYuSE/meOwDLxTvPXH6nnhknViujK0Ya8Xru8vV/IxiLAVzKd6BN01UHPvl/SR86wuMr5DCQ/8jYlFpqSOf5nEw+s2nm91tbTNq9l3qcCHRdsQYzS7LgNeQ6Ysz2pQc8+b2xKYhd97ul0nWKBNIYdN/tG1XArpy+mymxhVWmdMiEMJfU6tPp3a+mAg/VwwekFvyEQxVdkd3X7Mm085bidTYpHcjHbo7QoxgSNAln8QBG3TAoLjf9JHHZBhCNvZtLmsF+exdMnptRPK8J3mArwq7uCwjTpW+6+KbBBdYkbLHL6KhugMSiI+CJTJdfsbPMvgG3xvO6S2CSOa53KnwemxKOqjdELrEWO05p0no9UbzhDH9zc7IjRHnd12jFEB3uNJWULvNoL43Xy2fo+hSF6eBEBaf0STb0SwgzqFkb1Et/9KlvomBC6iGRKskZS6S9EyOllTEoTjpLumdz7QaVT8cfVTAOWhE5eX2Uniy/yU3gf1izL/Bg==",
                            "w": 120.00000000000001,
                            "h": 30.000000000000004,
                            "aspect": "fixed",
                            "title": "Duracion alta"
                        }]

                    }
                ]
            }]
        }],
        defaultLibraries: "diet-graphics",
        enabledLibraries: ["diet-graphics"],
    };
    let uiTheme = "default";
    let diagram;
    /*let previousStyle = {};
    let rootDescendants = [];*/
    let invalidNodes = [];
    let error = false;
    /*let errorMapping = {
        ONLY_ONE_ROOT_ALLOWED: "There can only be one root element",
        INVALID_METADATA: "This element's metadata has been changed and is no longer valid",
        DUPLICATED_NODE: "This element has been duplicated, delete one of the copies",
        SHOULD_NOT_HAVE_PARENT: "This element can have no parents, remove any incoming edges",
        SHOULD_HAVE_PARENT: "This element has to have a parent, connect it to another element via a new edge",
        WRONG_PARENT_TYPE: "This element cannot be a direct child of the given parent",
        MULTIPLE_PARENTS: "An element can only have one parent",
        INVALID_VALUE: "The introduced value is not valid",
        MISSING_CONTAINER: "This element should be placed in one of the swim-lanes so its value is properly set",
        STRAY_NODE: "All elements should be directly or indirectly connected to the root",
        INVALID_DIAGRAM: "ERROR: The diagram could not be saved. If you cannot properly see the error message press 'Enter' with no shape selected on the diagram"
    }*/

    //TODO: Change to endpoint call to retrieve the xml file
    let xhttp = new XMLHttpRequest();
    xhttp.open("GET", diagramFile, false);
    xhttp.overrideMimeType('application/xml');
    xhttp.send();
    let svg = xhttp.responseXML;
    let templateXml = decompressXML($(svg).find("svg").attr("content"));
    xhttp.open("GET", errorFile, false);
    xhttp.send();
    let errorMessage = xhttp.responseXML;

    //Set the default edge style to the first edge on the diagram
    let edges = $(templateXml).find("[edge='1']");
    let edgeStyle = $(edges[0]).attr("style");
    let jsonStyle = JSON.parse('{"' + edgeStyle.replace(/;$/, '"').replaceAll("=", '":"').replaceAll(";", '","') + "}");
    conf.defaultEdgeStyle = jsonStyle;

    //Set the data attribute of the container for the plugin to properly load the diagram
    let xmlText = new XMLSerializer().serializeToString(templateXml);

    /*let diagramContainer = $("#diagram");
    diagramContainer.attr("data", xmlText);*/

    function handleCLick() {
        diagram = DiagramEditor.editElement($("#diagram")[0], conf, uiTheme, formatVerifier, doneCallBack, null, exportCallBack,
            ["saveAndExit=0", "format=0", "splash=0", "p=svgdata"]);
    }

    /*diagramContainer.on('click', function () {

    });*/

    /**
     * Callback that checks the content of the diagram, prevents modifications from being saved in case of error and
     * highlights incorrect nodes
     * @param xmlData Object containing a compressed xml diagram data with all changes made by the user. Parameter has
     * to be an object in order for the value to be passed by reference.
     * @returns {*|boolean} true if the content is valid false otherwise
     */
    let formatVerifier = function (xmlData) {
        let xmlDoc = decompressXML(xmlData.data);
        invalidNodes = [];
        templateXml = xmlDoc;
        diagramParsing.cacheRootDescendants(templateXml);
        let baseNodes = $(templateXml).find('[nodeType=' + NodeTypeMapping.BASE + ']');
        let intermediateNodes = $(templateXml).find('[nodeType=' + NodeTypeMapping.INTERMEDIATE + ']');
        let durationNodes = $(templateXml).find('[nodeType=' + NodeTypeMapping.DURATION + ']');
        let dataNodes = $(templateXml).find('[nodeType=' + NodeTypeMapping.DATA + ']');
        // All nodes have to be validated so that all errors are highlighted at once
        let isDataValid = diagramParsing.validateRootNode(templateXml, invalidNodes);
        isDataValid = diagramParsing.validateTitleNode(templateXml, invalidNodes) && isDataValid;
        isDataValid = diagramParsing.validateNodeGroup(baseNodes, diagramParsing.baseNodeValidator, templateXml, invalidNodes) && isDataValid;
        isDataValid = diagramParsing.validateNodeGroup(intermediateNodes, diagramParsing.intermediateNodeValidator, templateXml, invalidNodes) && isDataValid;
        isDataValid = diagramParsing.validateNodeGroup(durationNodes, diagramParsing.durationNodeValidator, templateXml, invalidNodes) && isDataValid;
        isDataValid = diagramParsing.validateNodeGroup(dataNodes, diagramParsing.dataNodeValidator, templateXml, invalidNodes) && isDataValid;
        if (isDataValid) {
            let errorFirstElement = $(errorMessage).find('root>mxCell')[0]
            removeErrorMessage($(errorFirstElement).attr("id"));
        } else {
            addErrorMessage();
        }
        xmlData.data = (new XMLSerializer()).serializeToString(templateXml);
        return isDataValid;
    }

    /**
     * Callback that gets called after a successful save and makes a request for an export the diagram content into
     * an SVG file. For this export to be successful 'svgdata' plugin must be loaded into the editor
     * https://www.diagrams.net/doc/faq/plugins
     */
    let doneCallBack = function () {
        this.postMessage({action: 'export', format: 'xmlsvg', border: '20'});
        console.log(diagramParsing.getJsonData(templateXml));
    }

    /**
     * Callback that gets called after the diagram content is exported and generates a file
     * @param data Compressed svg content in base64
     */
    let exportCallBack = function (data) {
        //TODO: change into endpoint call that saves file in the database
        let svgString = b64DecodeUnicode(data.replace("data:image/svg+xml;base64,", ""));
        let link = document.createElement('a');
        link.download = 'parent_test.drawio.svg';
        let blob = new Blob([svgString], {type: 'data:image/svg+xml'});
        link.href = window.URL.createObjectURL(blob);
        link.click();
    }

    function b64DecodeUnicode(str) {
        // Decode from bytestream, to percent-encoding, to original string.
        return decodeURIComponent(atob(str).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }

    function addErrorMessage() {
        if (!error) {
            $("#error").text(errorMapping.INVALID_DIAGRAM);
            // Add error container to diagram
            $($(errorMessage).find('root>mxCell')[0]).attr("parent", $($(templateXml).find('root>mxCell')[0]).attr("id"));
            $(templateXml).find('root').append($(errorMessage).find('root').html());
            // Position it in the top-left corner
            let shape = $(templateXml).find('[data=errorContainer]').find('mxGeometry');
            $(shape).attr("x", diagram.getBounds().x - diagram.getBounds().translateX);
            $(shape).attr("y", diagram.getBounds().y - diagram.getBounds().translateY);
            error = true;
        }
        let button = $(templateXml).find('[link]');
        $(button).attr("link", buildButtonLink());
    }

    function removeErrorMessage(errorContainerId) {
        $("#error").text("Formato correcto");
        let errorContainer = $(templateXml).find('[id=' + errorContainerId + ']');
        let childElements = $(templateXml).find('[parent=' + errorContainerId + ']');
        for (let i = 0; i < childElements.length; i++) {
            let element = childElements[i];
            let elementId = $(element).attr("id");
            if (!elementId) {
                element = $(element).parent();
                elementId = $(element).attr("id");
            }
            removeErrorMessage(elementId);
        }
        $(errorContainer).remove();
        error = false;
    }

    function buildButtonLink() {
        let actions = {actions: []};
        let highlightActions = {highlight: {cells: invalidNodes}};
        actions.actions.push(highlightActions);
        let maxX = Number.NEGATIVE_INFINITY;
        let minX = Number.POSITIVE_INFINITY;
        let maxY = Number.NEGATIVE_INFINITY;
        let minY = Number.POSITIVE_INFINITY;
        let padding = 200;
        for (let i = 0; i < invalidNodes.length; i++) {
            let nodeRect = getNodeBoundingRect(invalidNodes[i]);
            if (nodeRect.x + nodeRect.width > maxX) {
                maxX = nodeRect.x + nodeRect.width;
            }
            if (nodeRect.x < minX) {
                minX = nodeRect.x;
            }
            if (nodeRect.y + nodeRect.height > maxY) {
                maxY = nodeRect.y + nodeRect.height;
            }
            if (nodeRect.y < minY) {
                minY = nodeRect.y;
            }
        }
        let viewBox = {
            viewbox: {
                "x": minX - padding / 2,
                "y": minY - padding / 2,
                "width": maxX - minX + padding,
                "height": maxY - minY + padding
            }
        }
        actions.actions.push(viewBox);
        return 'data:action/json,' + JSON.stringify(actions);
    }

    function getNodeBoundingRect(nodeId) {
        let node = $(templateXml).find('[id=' + nodeId + ']');
        let container = $(templateXml).find('[id=' + $(node).children(":first").attr("parent") + ']');
        let nodeGeometry = $(node).find("mxGeometry");
        let boundingRect = {
            x: parseInt($(nodeGeometry).attr("x"), 10),
            y: parseInt($(nodeGeometry).attr("y"), 10),
            width: parseInt($(nodeGeometry).attr("width"), 10),
            height: parseInt($(nodeGeometry).attr("height"), 10),
        }
        if (container.length > 0) {
            let containerGeometry = $(container).find("mxGeometry");
            if (containerGeometry.length > 0) {
                boundingRect.x += parseInt($(containerGeometry).attr("x"), 10);
                boundingRect.y += parseInt($(containerGeometry).attr("y"), 10);
            }
        }
        return boundingRect;
    }


    return <>

        <div id="error" style={{color: "darkred"}}>Aquí se muestran los mensajes de error</div>
        <div id="diagram" style={{width: "100%", height: "1000px", backgroundColor: "#00eaff", position: "relative"}}
             onClick={handleCLick} data={xmlText}>

        </div>
    </>
}



/*
    /!**
     * Changes background and border color of the given node to indicate an error
     * @param node Node that contains some kind of error
     *!/
    function highlightNode(node) {
        let dataNodeId = $(node).attr("id");
        invalidNodes.push(dataNodeId);
        //Check if the node has been previously highlighted
        if (!previousStyle[dataNodeId]) {
            let style = $(node).children(":first").attr("style");
            let fillColor = "#F26D68";
            let strokeColor = "#6F0000";
            //Store the previous style
            previousStyle[$(node).attr("id")] = style;
            style = style.replace(/fillColor=.*?(?=;)/, 'fillColor=' + fillColor);
            style = style.replace(/strokeColor=.*?(?=;)/, 'strokeColor=' + strokeColor)
            $(node).children(":first").attr('style', style);
        }
    }

    /!**
     * Reverts a node to it previous style
     * @param node Node that no longer contains errors
     *!/
    function revertNode(node) {
        if (previousStyle[$(node).attr("id")]) {
            $(node).children(":first").attr('style', previousStyle[$(node).attr("id")]);
            delete previousStyle[$(node).attr("id")];
        }
    }*/
/*
    /!**
     * Creates an array that contains the id all descendants, i.e. all direct or indirect children, of the root node.
     * @returns {*[]} Node id array
     *!/
    function getRootDescendants() {
        let root = $(templateXml).find("[nodeType=root]");
        rootDescendants = [];
        getDescendants(root, rootDescendants);
        return rootDescendants;
    }

    /!**
     * Adds to the given array all descendants of the given node. The parent-child relationship is checked using the
     * concept of edges provided by diagram.net. Edges are arrow-shaped connectors that, when connecting two nodes,
     * contain both a 'target' and 'source' attribute, corresponding to the id of the parent node and the id of
     * the child node, respectively.
     * https://www.diagrams.net/blog/use-connectors
     * @param node
     * @param descendantsArray Node id array
     *!/
    function getDescendants(node, descendantsArray) {
        let edges = $(templateXml).find("[source=" + $(node).attr("id") + "]");

        for (let i = 0; i < edges.length; i++) {
            let edge = edges[i];
            let child = $(templateXml).find("[id=" + $(edge).attr("target") + "]");
            let childId = $(child).attr("id");
            //Check for possible recursion
            if (!descendantsArray.includes(childId)) {
                descendantsArray.push(childId);
                getDescendants(child, descendantsArray);
            }
        }
    }

    /!**
     * Checks if a node is an only child of a given 'nodeType' meaning:
     *  - The node has only one parent
     *  - The parent node has a corresponding nodeType attribute that matches the one given by parameter
     *  - The node is a direct or indirect child of the root (this conditions prevents recursion in the node tree)
     * @param node
     * @param parentNodeType
     * @returns {{result: boolean, error: string}}
     *!/
    function isOnlyChildOfNodeType(node, parentNodeType) {
        let incomingEdge = $(templateXml).find("[target=" + $(node).attr("id") + "]");
        let isNodeValid;

        // No parent or more than one
        if (incomingEdge.length !== 1) {
            if (incomingEdge.length === 0) {
                parentNodeType === NodeTypeMapping.NONE ?
                    isNodeValid = {result: true, error: ""} :
                    isNodeValid = {result: false, error: errorMapping.SHOULD_HAVE_PARENT};
            } else {
                isNodeValid = {result: false, error: errorMapping.MULTIPLE_PARENTS};
            }
        }
        // Only one parent
        else {
            // Node should have no parents but has one
            if (parentNodeType === NodeTypeMapping.NONE) {
                isNodeValid = {result: false, error: errorMapping.SHOULD_NOT_HAVE_PARENT};
            }
            // Node is not a descendant of the root node
            else if (!rootDescendants.includes($(node).attr("id"))) {
                isNodeValid = {result: false, error: errorMapping.STRAY_NODE};
            } else {
                let parent = $(templateXml).find("[id=" + $(incomingEdge).attr("source") + "]");
                // Node can have any kind of node as a parent
                if (parentNodeType === NodeTypeMapping.ANY && $(parent).attr("nodeType")) {
                    isNodeValid = {result: true, error: ""};
                }
                // Node should have a parent with a specific nodeType
                else {
                    $(parent).attr("nodeType") === parentNodeType ?
                        isNodeValid = {result: true, error: ""} :
                        isNodeValid = {result: false, error: errorMapping.WRONG_PARENT_TYPE};
                }
            }
        }
        return isNodeValid;
    }

    /!**
     * Checks if a given node has been put inside a container. This check is necessary since containers are being used
     * so that their child nodes can inherit values from them via diagrams.net placeholder functionality:
     * https://www.diagrams.net/blog/placeholders
     * @param node
     * @returns {{result: boolean, error: string}}
     *!/
    function hasContainerParent(node) {
        let containerId = $(node).children(":first").attr("parent");
        let container = $(templateXml).find("[id=" + containerId + "]");
        let isNodeValid = {result: true, error: ""};
        if ($(container).attr("nodeType") !== NodeTypeMapping.CONTAINER) {
            isNodeValid = {result: false, error: errorMapping.MISSING_CONTAINER}
        }
        return isNodeValid;
    }

    /!**
     * Checks whether a node has a valid and unique 'data' attribute
     * @param node
     * @param nodeMapping Map of valid values for the 'data' attribute
     * @returns {{result: boolean, error: string}}
     *!/
    function isOnlyNodeWithMapping(node, nodeMapping) {
        let data = $(node).attr("data");
        let nodesWithSameData = $(templateXml).find('[data=' + data + ']');
        let isNodeValid = {result: true, error: ""};

        if(nodesWithSameData?.length > 1){
            isNodeValid = {result: false, error: errorMapping.DUPLICATED_NODE};
        }
        if (!Object.values(nodeMapping).includes(data)) {
            isNodeValid = {result: false, error: errorMapping.INVALID_METADATA};
        }

        return isNodeValid;
    }

    /!**
     * Checks whether the root node meets the following conditions:
     *  - There is only one element that has the nodeType attribute set to ROOT
     *  - It has no parent nodes
     * @returns {boolean} true if all conditions are met, false otherwise
     *!/
    function validateRootNode() {
        let root = $(templateXml).find('[nodeType=' + NodeTypeMapping.ROOT + ']');
        let isNodeValid = {result: false, error: errorMapping.ONLY_ONE_ROOT_ALLOWED};
        if (root && root.length === 1) {
            isNodeValid = isOnlyChildOfNodeType(root, null);
        }
        for (let i = 0; i < root.length; i++) {
            let node = $(root[i]);
            if (!isNodeValid.result) {
                highlightNode(node);
            } else {
                revertNode(node);
            }
            $(node).attr("tooltip", isNodeValid.error);
        }
        return isNodeValid.result;
    }

    /!**
     * Validates a group of nodes using the given validator
     * @param nodes Group on nodes of the same nodeType
     * @param nodeGroupValidator Function that applies a set of conditions to the node group
     * @returns {boolean} true if all nodes in the group meet the conditions, false otherwise
     *!/
    function validateNodeGroup(nodes, nodeGroupValidator) {
        let isNodeValid = {result: true, error: ""};
        let isGroupValid = true;
        for (let i = 0; i < nodes.length; i++) {
            let node = nodes[i];
            isNodeValid = nodeGroupValidator(node);
            if (!isNodeValid.result) {
                highlightNode(node);
                isGroupValid = false;
            } else {
                revertNode(node);
            }
            $(node).attr("tooltip", isNodeValid.error);
        }
        return isGroupValid;
    }

    /!**
     * Checks if a node of type BASE meets the following conditions:
     * - It is a child of the root node
     * @param baseNode Node being validated
     * @returns {{result: boolean, error: string}} Validation result and error message in case of failure
     *!/
    function baseNodeValidator(baseNode) {
        let isNodeValid = isOnlyChildOfNodeType(baseNode, NodeTypeMapping.ROOT);
        if(isNodeValid.result){
            isNodeValid = isOnlyNodeWithMapping(baseNode, BaseNodeMapping);
        }
        return isNodeValid;
    }

    /!**
     * Checks if a node of type INTERMEDIATE meets the following conditions:
     *  - It is a child of a BASE node or another INTERMEDIATE node
     * @param intermediateNode Node being validated
     * @returns {{result: boolean, error: string}} Validation result and error message in case of failure
     *!/
    function intermediateNodeValidator(intermediateNode) {
        let isNodeValid = isOnlyChildOfNodeType(intermediateNode, NodeTypeMapping.BASE);
        if (!isNodeValid.result) {
            isNodeValid = isOnlyChildOfNodeType(intermediateNode, NodeTypeMapping.INTERMEDIATE);
        }
        return isNodeValid;
    }

    /!**
     * Checks if a node of type DURATION meets the following conditions:
     *  - It is a child of a BASE node or an INTERMEDIATE node
     *  - It is placed inside a proper unit container
     * @param durationNode Node being validated
     * @returns {{result: boolean, error: string}} Validation result and error message in case of failure
     *!/
    function durationNodeValidator(durationNode) {
        let isNodeValid = isOnlyChildOfNodeType(durationNode, NodeTypeMapping.INTERMEDIATE);
        if (!isNodeValid.result) {
            isNodeValid = isOnlyChildOfNodeType(durationNode, NodeTypeMapping.BASE);
        }
        if (isNodeValid.result) {
            isNodeValid = hasContainerParent(durationNode);
        }
        return isNodeValid;
    }

    /!**
     * Checks if a node of type DATA meets the following conditions:
     *  - Is a child of any nodeType
     *  - It is placed inside a proper unit container
     *  - It contains a valid numeric value
     * @param dataNode Node being validated
     * @returns {{result: boolean, error: string}|{result: boolean, error: string}|{result: boolean, error: string}}
     *!/
    function dataNodeValidator(dataNode) {
        let val = $(dataNode).attr("value");
        let isNodeValid = isOnlyChildOfNodeType(dataNode, NodeTypeMapping.ANY);
        if (!isNodeValid.result) {
            return isNodeValid;
        }
        isNodeValid = hasContainerParent(dataNode);
        if (!isNodeValid.result) {
            return isNodeValid;
        }
        isNodeValid = isFloat(val);
        return isNodeValid;
    }

    function isFloat(val) {
        let floatRegex = /^<?\d+(?:[.,]\d*?)?$/;
        return (floatRegex.test(val) ? {result: true, error: ""} : {result: false, error: errorMapping.INVALID_VALUE});
    }*/